import { render } from "./value-settingfp.vue?vue&type=template&id=53702388"
import script from "./value-settingfp.vue?vue&type=script&lang=js"
export * from "./value-settingfp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__